import React from 'react';
import { Link } from 'react-router-dom';
import { HomeNavbar } from '../components/home/HomeNavbar';
import { HeroSection } from '../components/home/HeroSection';
import { FeaturesSection } from '../components/home/FeaturesSection';
import { WhyUsSection } from '../components/home/WhyUsSection';
import { CTASection } from '../components/home/CTASection';

// Public marketing homepage — served at "/". No auth required.
// Do NOT wire into Sidebar; this exists outside the app shell.
export const HomePage = () => (
  <div className="min-h-screen bg-white text-[#0F0F0F] scroll-smooth" data-testid="home-page">
    <HomeNavbar />
    <main>
      <HeroSection />
      <SocialProofBar />
      <FeaturesSection />
      <WhyUsSection />
      <CTASection />
    </main>
    <HomeFooter />
  </div>
);

// Thin marquee-style social-proof bar between hero and features.
const SocialProofBar = () => {
  const items = [
    '19,000+ Vetted Indian Creators',
    'Pan India Coverage',
    'Nano to Celebrity',
    'IG + YouTube',
  ];
  const strip = [...items, ...items, ...items];
  return (
    <section
      className="bg-white border-y border-black/[0.06] py-4 overflow-hidden"
      data-testid="social-proof-bar"
    >
      <div className="marquee-track whitespace-nowrap flex gap-10 text-xs md:text-sm font-medium text-[#4B5563] uppercase tracking-[0.15em]">
        {strip.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-10 shrink-0">
            {item}
            <span className="text-[#FF451A]">•</span>
          </span>
        ))}
      </div>
      <style>{`
        .marquee-track {
          animation: marquee-scroll 40s linear infinite;
        }
        @keyframes marquee-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-33.3333%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>
    </section>
  );
};

const HomeFooter = () => (
  <footer className="bg-white border-t border-black/[0.06] py-10" data-testid="home-footer">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-start md:items-center">
      <div>
        <div className="text-lg font-bold tracking-tight">
          <span className="text-[#0F0F0F]">Vy</span>
          <span className="text-[#FF451A]">vre</span>
        </div>
        <div className="text-xs text-[#4B5563] mt-1">Creator Intelligence Platform</div>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-2 md:justify-center text-sm text-[#4B5563]">
        <a href="#features-section" className="hover:text-[#FF451A] transition-colors">Discover Creators</a>
        <a href="#for-brands" className="hover:text-[#FF451A] transition-colors">For Brands</a>
        <a href="#for-agencies" className="hover:text-[#FF451A] transition-colors">For Agencies</a>
        <Link to="/login" className="hover:text-[#FF451A] transition-colors">Sign In</Link>
        <Link to="/privacy" className="hover:text-[#FF451A] transition-colors" data-testid="home-footer-privacy">Privacy</Link>
        <Link to="/terms" className="hover:text-[#FF451A] transition-colors" data-testid="home-footer-terms">Terms</Link>
      </div>
      <div className="text-xs text-[#6B7280] md:text-right">
        © 2026 Vyvre. All rights reserved.
      </div>
    </div>
  </footer>
);

export default HomePage;
